import tw, { styled, theme } from "twin.macro"

export const StyledDivTable = styled.div`
    .table-cell {
        height: auto;
        padding: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        border-bottom: 1px solid #f0f0f0;
        transition:
            background 0.2s,
            border-color 0.2s;
    }

    .table-cell.table-header-cell {
        height: 100%;
    }

    .table-cell.table-selection-column {
        padding-right: 0;
    }

    .table-thead {
        ${tw`sticky z-10`}
    }

    .table-thead .table-header-row {
        display: flex;
        align-items: center;
    }

    .table-thead .table-header-row,
    .table-thead .table-header-cell {
        ${theme`typo.mregular`};
        background-color: ${theme`colors.gray200`};
    }

    .table-thead .table-header-cell.table-header-cell-has-sorters:hover {
        cursor: pointer;
        background-color: ${theme`colors.gray300`};
    }

    .table-body-row.table-body-row-expanded .table-cell {
        background-color: ${theme`colors.lightgray200`};
    }

    .table-body-row-wrapper .table-body-row:hover:not(.table-body-row-expanded-header) .table-cell {
        background-color: ${theme`colors.gray200`};
        cursor: pointer;

        &:first-of-type::before {
            content: "";
            position: absolute;
            width: 2px;
            height: calc(100% + 2px);
            background-color: ${theme`colors.primary`};
            top: -1px;
            left: 0;
        }
    }

    .table-body-row.table-row-selected .table-cell {
        background-color: ${theme`colors.navyblue200`};
    }

    .table-body-row.table-row-selected:not(.table-row-disabled):hover .table-cell {
        background-color: ${theme`colors.navyblue300`};
    }

    .table-header-row .table-cell-arrow,
    .table-body-row .table-cell-arrow {
        cursor: pointer;
        > div {
            min-width: 20px;
            font-size: 20px;
            transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
            transform: rotate(0deg);
            color: ${theme`colors.gray500`};
        }

        &:hover > div {
            color: ${theme`colors.gray600`};
        }

        &[data-expanded="true"] > div {
            color: ${theme`colors.gray800`};
            transform: rotate(90deg);
        }
    }

    .table-body-row.table-row-disabled .table-cell:not(.table-cell-arrow) {
        cursor: not-allowed !important;
        color: ${theme`colors.text_disable`};
    }

    .table-body-row.un-expandable:hover,
    .table-body-row.table-body-row-expanded:hover {
        .table-cell-arrow {
            cursor: default !important;
        }
    }

    [data-measuring="true"] {
        .table-thead .table-header-row,
        .table-thead .table-header-cell.table-header-cell-has-sorters:hover {
            background-color: ${theme`colors.gray200`};
        }
    }
`
